import { render } from "./announcements.vue?vue&type=template&id=1b15c829&scoped=true"
import script from "./announcements.vue?vue&type=script&lang=js"
export * from "./announcements.vue?vue&type=script&lang=js"

import "./announcements.vue?vue&type=style&index=0&id=1b15c829&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b15c829"]])

export default __exports__